<template>
    <v-card elevation="0">
        <configs-popup-edit-info ref="configs-popup-edit-info"></configs-popup-edit-info>
        <popup-edit-version ref="popup-edit-version"></popup-edit-version>
        <c-edit-audience-popup ref="c-edit-audience-popup"></c-edit-audience-popup>
        <v-card-actions class="ma-0 pa-0">
            <c-release-table
                    style="width: 100%"
                    v-on:show-configs-popup-edit-info="showEditInfoPopup"
                    v-on:show-popup-edit-version="showEditVersionPopup"
                    v-on:show-c-edit-audience-popup="showEditAudiencesPopup"
            ></c-release-table>
        </v-card-actions>
    </v-card>
</template>

<script>

import CReleaseTable from "@/modules/mconfigs/views/release/c-release-table";
import CEditAudiencePopup from "@/modules/mconfigs/views/release/popups/c-edit-audience-popup";
import ConfigsPopupEditInfo from "@/modules/mconfigs/views/popups/configs-popup-edit-info";
import {ConfigBackendUtils} from "@/modules/mconfigs/database/ConfigBackendUtils";
import PopupEditVersion from "@/modules/common/popup-edit-version";

export default {
    name: "c-release",
    components: {PopupEditVersion, ConfigsPopupEditInfo, CEditAudiencePopup, CReleaseTable},
    data: () => ({
    }),
    methods:{
        showEditInfoPopup(config){
            this.$refs['configs-popup-edit-info'].show(config, function (config, newInfo) {
                ConfigBackendUtils.setConfigInfo([{"name":config.name, "info": newInfo}])
                .then(() => {
                    this.$notify({title: 'Info successfully updated!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.$notify({title: 'Info update failed!', text: error, type: "error"});
                })
            })
        },
        showEditVersionPopup(config){
            let ref = this.$refs['popup-edit-version'];
            ref.show(config.minver, config.maxver, function (min, max){

                var validateVersion = function (version){
                    var data = version.split(".");
                    var final = "";
                    for (let i = 0; i < data.length; i++) {
                        var int = parseInt(data[i]);
                        if (!Number.isInteger(int)){
                            int = 0;
                        }
                        final += int + (i < data.length - 1 ? "." : "")
                    }
                    return final;
                }

                min = validateVersion(min);
                max = validateVersion(max);

                ConfigBackendUtils.setConfigClientVersion([{"name": config.name, "minver":min, "maxver":max}])
                .then(() => {
                    ref.hide()
                    this.$notify({title: 'Config audiences successfully updated!', text: "", type: "succes"});
                })
                .catch((error) => {
                    ref.hide()
                    this.$notify({title: 'Config audiences updated failed!', text: error, type: "error"});
                })
            })
        },
        showEditAudiencesPopup(config){
            this.$refs['c-edit-audience-popup'].show(config)
        },
    },
}
</script>

<style scoped>

</style>